import { Alchemy, Network } from "alchemy-sdk";

const config = {
    apiKey: "HGWgCONolXMB2op5UjPH1YreDCwmSbvx",
    network: Network.ETH_MAINNET,
};

export const alchemy = new Alchemy(config);
